<template>
    <div class="daily-deals-inner p-2">
        <div class="daily-deals-top">
            <a :href="productUrl" class="product-image">
                <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" alt="product-image">
            </a>
        </div>
        <div class="product-info">
            <div class="product-price" v-html="product.formatted_price"></div>
        </div>
        <div class="deal-progress">
            <div v-if="progress != 0" class="progress">
                <div class="progress-label">
                    <img src="/themes/storefront/public/images/fire_icon.svg" alt="fire_icon" />
                    <span>{{ $trans('storefront::product_card.sold') +' '+product.pivot.sold }}</span>
                </div>
                <div class="progress-bar" :style="{ width: progress +'%' }"></div>
            </div>
            <div v-else class="progress">
                <div class="progress-label">
                    <span>{{ $trans('storefront::product_card.just_opened') }}</span>
                </div>
                <div class="progress-bar" style="width: 1rem"></div>
            </div>
            <div class="daily-deals-countdown"></div>
        </div>
    </div>
</template>

<script>
    import ProductCardMixin from '../../mixins/ProductCardMixin';

    export default {

        mixins: [
            ProductCardMixin,
        ],

        props: ['product'],

        computed: {
            progress() {
                return (this.product.pivot.sold / this.product.pivot.qty * 100);
            },
        },
        mounted() {
            $(this.$el).find('.daily-deals-countdown').countdown({
                until: new Date(this.product.pivot.end_date),
                format: 'DHMS',
                compact: true,
                labels: [
                    this.$trans('storefront::product_card.years'),
                    this.$trans('storefront::product_card.months'),
                    this.$trans('storefront::product_card.weeks'),
                    this.$trans('storefront::product_card.days'),
                    this.$trans('storefront::product_card.hours'),
                    this.$trans('storefront::product_card.minutes'),
                    this.$trans('storefront::product_card.seconds'),
                ],
            });
        },
    };
</script>
